<template>
  <Navbar></Navbar>
  <div class="about-page">
    <div class="about-first">
      <div class="about-kv-t1">
        蜂巢汽车智能制造
      </div>
      <div class="about-video-list">
        <div class="about-video-item"
          @click="clickFullVideo('/assets/about/1-1-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-1.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              发动机智能制造
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

        <div class="about-video-item"
          @click="clickFullVideo('/assets/about/1-2-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-2.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              变速器智能制造
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

        <div class="about-video-item"
          @click="clickFullVideo('/assets/about/1-3-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-3.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              电子智能制造
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

      </div>
    </div>
    <div class="about-full-video" v-show="isFullVideo">
      <div class="img-box">
        <video :src="fullVideo" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
          x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
      </div>
      <div class="about-full-video-close" @click="closeFullVideo()">
        <img class="pc-pad" src="/assets/about/close.png" alt="">
        <img class="mb-only" src="/assets/manufacture/close-m.png" alt=""></img>
      </div>

    </div>
    <div class="about-map-box">
      <div class="img-box img-box-height">
        <img class="pc-pad" src="/assets/manufacture/map.jpg" alt="">
        <img class="mb-only" src="/assets/manufacture/map-m.jpg" alt="">
      </div>


      <div class="map-detail-box" v-show="isClickMapAnchor">
        <div class="map-detail-d">
          <div class="img-box map-detail-left">
            <img :src="isPc ? mapHoverBoxs1.img : mapHoverBoxs1.imgM" alt="">
          </div>
          <div class="map-detail-right">
            <div class="map-right-top">
              <div class="map-detail-name">
                {{ mapHoverBoxs1.name }}
              </div>

              <div class="map-detail-address">
                <img src="/assets/contact/address-icon.png" alt=""></img>
                <span>
                  {{ mapHoverBoxs1.address }}
                </span>
              </div>

            </div>

            <div class="map-right-bottom" v-html="mapHoverBoxs1.detail"></div>

          </div>

        </div>
        <div class="map-detail-icon" @click="closeMapAnchor">
          <img src="/assets/about/close.png" alt="">
        </div>


      </div>
      <div class="about-map-layout about-map-item">
        <div class="about-map-text">
          <div class="about-map-title">
            智能制造全球布局
          </div>
          <div class="about-map-btn-list" v-if="!isPc">
            <div class="about-map-btn" :class="mapHoverBoxs2 == 1 ? 'active' : ''" @click=" mapHoverBoxs2 = 1">
              <div style="background: #E70012;"></div>
              发动机工厂
            </div>
            <div class="about-map-btn" :class="mapHoverBoxs2 == 2 ? 'active' : ''" @click=" mapHoverBoxs2 = 2">
              <div style="background: #57C0BF;"></div>
              变速器工厂
            </div>
            <div class="about-map-btn" :class="mapHoverBoxs2 == 3 ? 'active' : ''" @click=" mapHoverBoxs2 = 3">
              <div style="background: #0F65B5;"></div>
              电子工厂
            </div>

          </div>

        </div>

        <!-- 7个 -->
        <!-- 保定 -->
        <div class="map-hover-box map-hover-box7 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(3)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              蜂巢传动科技河北有限公司徐水分公司
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box3 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(7)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              发动机徐水工厂
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box8 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(9)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              发动机定兴工厂
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box9 " v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(14)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
               张家港工厂
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <!-- 天津 -->
        <div class="map-hover-box map-hover-box10 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(6)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              发动机天津工厂
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box11" v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(15)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              常熟工厂
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box12 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(1)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,26 50,26  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              蜂巢智行传动系统（江苏）有限公司
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box2 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(5)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              蜂巢动力系统（江苏）有限公司
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box13" v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(16)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              无锡工厂
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box15 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(0)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              蜂巢传动科技（重庆）有限公司
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box5 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(8)">

          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              蜂巢动力系统（重庆）有限公司
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box4 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(10)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              蜂巢汽车动力系统（湖北）有限公司
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box16" v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(12)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,46 50,46  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              蜂巢动力系统（江西）有限公司
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box17 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(11)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              蜂巢动力系统（泰国）有限公司
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box18" v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(4)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              蜂巢传动系统（江苏）有限公司
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box1" v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(13)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,26 50,26  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              蜂巢蔚领动力科技（江苏）有限公司
            </div>
          </div>
        </div>


        <div class="map-hover-box map-hover-box19" v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(2)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              蜂巢传动科技邳州有限公司
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box6" v-if="mapHoverBoxs2 == 1">
        </div>




      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';
const swiperRefs = ref(null);
const swiperInstances = ref([]);

const hoverItemRefs = ref(1);

const mapHoverBoxs = ref(1);
const mapHoverBoxs2 = ref(1);

const fullVideo = ref('')
const isFullVideo = ref(false);

const isPc = ref(window.innerWidth > 768);




const hoverListDeatil = ref([
  {
    name: '蜂巢传动科技（重庆）有限公司',
    img: '/assets/manufacture/bevel/8.png',
    imgM: '/assets/manufacture/bevel/8-m.jpg',
    address: '重庆市永川区',
    detail: '位于重庆市永川区，占地面积6.7万㎡，规划产能25万台/年，主要生产9AT/9HAT变速器。工厂引进德国Gleason、Präwema、Pfauter、Junkers、Felsomat等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成MES数字化管控、RFID全流程溯源、NVH实时监测、高精度闭环检测与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢智行传动系统（江苏）有限公司',
    img: '/assets/manufacture/bevel/13.png',
    imgM: '/assets/manufacture/bevel/13-m.jpg',
    address: '江苏省镇江市泰州市',
    detail: '位于江苏省泰州市，占地面积1.2万㎡，规划产能：液压模块、双离合模块组装各50万台/年及双离合模块壳体25万/年，主要生产液压模块/双离合模块&壳体。工厂引进德国GROB、THYSSENKRUPP、KUKA及瑞士ABB等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成全功能全性能台架测试、100%自动化台架校验、MES数字化管控与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢传动科技邳州有限公司',
    img: '/assets/manufacture/bevel/3.png',
    imgM: '/assets/manufacture/bevel/3-m.jpg',
    address: '江苏省邳州市',
    detail: '位于江苏省邳州市，占地面积29.18万㎡，规划产能60万台/年，主要生产DHT-1/DHT-2/DHT-3/DHT-3L/150KW纯电驱动总成。工厂引进德国GROB、Zeiss及瑞士ABB等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成Discom测试系统、3D精密检测、激光打标溯源与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢传动科技河北有限公司徐水分公司',
    img: '/assets/manufacture/bevel/16.png',
    imgM: '/assets/manufacture/bevel/16-m.jpg',
    address: '河北省保定市徐水区',
    detail: '位于河北省保定市徐水区，占地面积14.5万㎡，规划产能120万台/年，主要生产7DCT/150kW/200kW纯电驱动总成。工厂引进德国GROB、PILLER、Weisser、Gleason、Profinoroll等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成Discom测试系统、总成全功能性能校验与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢传动系统（江苏）有限公司',
    img: '/assets/manufacture/bevel/12.png',
    imgM: '/assets/manufacture/bevel/12-m.jpg',
    address: '江苏省扬中市',
    detail: '位于江苏省扬中市，占地面积22万㎡，规划产能60万台/年，主要生产DHT/9DCT/135kW纯电驱动等混动及新能源变速器产品。工厂引进德国SW、Weisser、Gleason、Profinoroll、ALD等国际高端设备108台，以微米级精工细作，夯实精密制造基础。深度集成高精度机加工艺、NVH实时监测、智能电控、高清传感检测与AI视觉防错技术，搭配产线机器人自动化装配及全自动化定子/转子产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢动力系统（江苏）有限公司',
    img: '/assets/manufacture/bevel/5.png',
    imgM: '/assets/manufacture/bevel/5-m.jpg',
    address: '江苏省扬中市',
    detail: '位于江苏省扬中市，占地面积12万㎡，规划产能40 万台/年，主要生产1.5L/2.0L发动机。工厂引进德国GROB、Nagel、HELLER、KUKA/FANUC、MAG等国际高端设备，以微米级精工细作，夯实高端制造基础。深度集成 MES 数字化系统、物联网、高精度视觉扫描与 AI 视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '发动机天津工厂',
    img: '/assets/manufacture/bevel/15.png',
    imgM: '/assets/manufacture/bevel/15-m.jpg',
    address: '天津市海滨新区',
    detail: '位于天津市海滨新区，占地面积5万㎡，规划产能42万台/年，主要生产1.5L发动机。工厂引进日本Makino、HORKOS、Komatsu及德国Nagel、LARU等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成Artis监控、马波斯在线测量、智能传感与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '发动机徐水工厂',
    img: '/assets/manufacture/bevel/17.png',
    imgM: '/assets/manufacture/bevel/17-m.jpg',
    address: '河北省保定市徐水区',
    detail: '位于河北省保定市徐水区，占地面积6.7万㎡，规划产能60万台/年，主要生产1.5L/2.0L发动机。工厂引进德国GROB、Nagel、Junkers等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成MES数字化管控、马波斯在线测量、一码全流程溯源与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢动力系统（重庆）有限公司',
    img: '/assets/manufacture/bevel/8.png',
    imgM: '/assets/manufacture/bevel/8-m.jpg',
    address: '重庆永川区',
    detail: '位于重庆市永川区，占地面积 4.2 万㎡，规划产能22 万台/ 年，主要生产2.0L/2.4L/3.0L 发动机。工厂引进日本Makino、Mazak 及德国 Nagel、Junkers 等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成 RFID 全生命周期追溯、2D/3D精密检测与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '发动机定兴工厂',
    img: '/assets/manufacture/bevel/4.png',
    imgM: '/assets/manufacture/bevel/4-m.jpg',
    address: '河北省保定市定兴',
    detail: '位于河北省保定市定兴，占地面积23万㎡，规划产能20万台/年，主要生产2.0L柴油机、491QE汽油机。工厂引进英国Landis及德国DMG等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成整机全工况热试、过程实时监控溯源与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢汽车动力系统（湖北）有限公司',
    img: '/assets/manufacture/bevel/2.png',
    imgM: '/assets/manufacture/bevel/2-m.jpg',
    address: '湖北省大冶市',
    detail: '位于湖北省大冶市，占地面积10.7万㎡，规划产能15万台/ 年，主要生产2.0L发动机。工厂引进德国 GROB、HELLER 及瑞士 ABB、Kistler 等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成微米级精密检测、自动化涂胶注油与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢动力系统（泰国）有限公司',
    img: '/assets/manufacture/bevel/6.png',
    imgM: '/assets/manufacture/bevel/6-m.jpg',
    address: '泰国罗勇府',
    detail: '位于泰国罗勇府，占地面积 4.2 万㎡，规划产能装配线13万台/ 年、曲轴生产线10万根/年，主要生产 1.5L/2.0L/2.4L/3.0L 发动机及核心件。工厂引进日本KEYENCE及瑞士ABB等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成热处理工艺、激光精密视觉检测、全生命周期质量管控与 AI 视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢动力系统（江西）有限公司',
    img: '/assets/manufacture/bevel/7.png',
    imgM: '/assets/manufacture/bevel/7-m.jpg',
    address: '江西省上饶市',
    detail: '位于江西省上饶市，占地面积8万㎡，规划产能30万台/年，主要生产1.5L/2.0L发动机。工厂引进德国 KUKA、Siemens、Rexroth 及日本KEYENCE等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成微米级精密定位、MES数字化管控、智能调校与AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '蜂巢蔚领动力科技（江苏）有限公司',
    img: '/assets/manufacture/bevel/14.jpg',
    imgM: '/assets/manufacture/bevel/14-m.jpg',
    address: '江苏省泰州市',
    detail: '位于江苏省泰州市，占地面积2万㎡，主要生产涡轮增压器、氢燃料电池空压机、氢气循环泵等透平机械类产品。工厂引进意大利CEMB、德国Schenck及英国CVE等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成MES数字化管控、激光线扫与3D成像检测、AI视觉防错技术，搭配自动化机器人产线，实现从投料到下线的全流程智能防错与工序追溯，以全链路数字化管控，保障产品品质稳定可靠。'
  }, {
    name: '张家港工厂',
    img: '/assets/manufacture/bevel/9.png',
    imgM: '/assets/manufacture/bevel/9-m.jpg',
    address: '江苏省张家港市',
    detail: '位于江苏省张家港市，占地面积1.48万㎡，规划产能300万件/年，主要生产座舱域控/驾驶域控。工厂引进德国Siemens、日本Okuma、XRAY及美国Keysight等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成精密贴片焊接工艺、全流程EOL性能测试、精密探伤检测与AI视觉防错技术，搭配智能线体自动化管控，打造30万级洁净度生产环境，实现生产全流程工序管控与智能防错全覆盖，保障产品品质稳定可靠。'
  }, {
    name: '常熟工厂',
    img: '/assets/manufacture/bevel/10.png',
    imgM: '/assets/manufacture/bevel/10-m.jpg',
    address: '江苏省常熟市',
    detail: '位于江苏省常熟市，占地面积3.6万㎡，规划产能380万件/年，主要生产显示屏&功放。工厂引进德国Siemens、ERSA及日本Panasonic、AOI等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成精密电子制程工艺、AOI光学检测、全流程工序校验与AI视觉防错技术，搭配智能线体自动化管控，推进“黑灯工厂”建设，搭建千级、万级、十万级分级洁净生产体系，实现生产全流程工序管控与智能防错全覆盖，保障产品品质稳定可靠。'
  }, {
    name: '无锡工厂',
    img: '/assets/manufacture/bevel/11.png',
    imgM: '/assets/manufacture/bevel/11-m.jpg',
    address: '江苏省无锡市',
    detail: '位于江苏省无锡市，占地面积3万㎡，规划产能120万套/年，主要生产塑封IGBT/塑封SiC/灌封IGBT/灌封SiC。工厂引进德国ASM、Hesse、Pink及荷兰Boschman、BESI等国际高端设备，以微米级精工细作，夯实精密制造基础。深度集成芯片银烧结、铜线键合、精密塑封成型、成品精准检测与AI视觉防错技术，搭配智能线体自动化管控，实现生产全流程工序管控与智能防错全覆盖，保障产品品质稳定可靠。'
  }
])
console.log(hoverListDeatil.value.length);

const mapHoverBoxs1 = ref('');
const isClickMapAnchor = ref(false);


// 点击全屏播放视频
// 点击全屏播放视频
const clickFullVideo = (item) => {
  fullVideo.value = item;
  isFullVideo.value = true;
  $('body').css('overflow', 'hidden');
  $('body').css('height', '100vh');

  // 正确写法：获取原生 DOM 元素再调用 play()
  nextTick(() => {
    const $videos = $('.about-full-video video');
    $videos.each(function () {
      this.play().catch(err => {
        console.warn('视频播放失败:', err);
      });
    });
  });
};

const closeFullVideo = () => {
  fullVideo.value = '';
  isFullVideo.value = false;
  $('body').css('overflow', 'auto');
  $('body').css('height', 'auto');

  const $videos = $('.about-full-video video');
  $videos.each(function () {
    this.pause();
    this.currentTime = 0; // 重置播放位置
  });
};

// 地图锚点点击
const clickMapAnchor = (item) => {
  mapHoverBoxs1.value = hoverListDeatil.value[item];
  isClickMapAnchor.value = true;
}
const closeMapAnchor = () => {
  mapHoverBoxs1.value = '';
  isClickMapAnchor.value = false;
}


const initAllSwipers = async () => {
  await nextTick();
  const el = swiperRefs.value;
  if (el) {
    const swiper = new Swiper(el, {
      // loop: true,
      speed: 1300,
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      direction: "horizontal",
      simulateTouch: true,
      breakpoints: {
        768: {
        },
        1024: {
        }
      },
      on: {
        init: function () {
        },
        slideChangeTransitionStart(swiper) {
          let swiperIndex = swiper.realIndex;
        },
      },
    });
    swiperInstances.value.push(swiper);
  }
};
onMounted(() => {
  initAllSwipers()

})

</script>

<script>
export const pageConfig = {
  title: '智能制造 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'manufacture.html'
};

import { createApp } from 'vue';
import App from './manufacture.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./manufacture.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
// .img-box-height {
//   min-height: 100vh;
// }

.about-first {
  padding: 2.38rem 1.68rem 1.48rem;
  background: radial-gradient(0% 0% at 0% 0%, #F1F1F1 0%, #FFFFFF 100%);

  .about-kv-t1 {
    font-size: 0.56rem;
    color: #000;
    text-align: center;
    margin-bottom: 1rem;
  }

  .about-video-list {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    align-items: center;

    .about-video-item {
      flex: 1;
      overflow: hidden;
      height: 3.87rem;
      border-radius: 0.2rem;
      cursor: pointer;

      .about-video-bottom {
        height: 1rem;
        display: flex;
        padding: 0 0.3rem;
        align-items: center;
        justify-content: space-between;
        background: #fff;

        .about-video-title {
          font-size: 0.28rem;
          color: #000;
        }

        .about-video-play {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }
  }
}

.about-full-video {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;

  .about-full-video-close {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    width: 0.3rem;
    height: 0.3rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

}


.about-map-box {
  position: relative;

  .about-map-item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .about-map-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 1.08rem;
      color: #000;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .about-map-title {
        font-size: 0.5rem;
        font-weight: 500;
        margin-bottom: 0.3rem;
      }

      .about-map-desc {
        font-weight: 300;
        font-size: 0.2rem;
      }


    }

    .map-hover-box {
      position: absolute;
      color: #000000;
      width: 0;
      height: 0;
      border: #E70012 0.08rem solid;
      border-radius: 0.08rem;
      text-align: center;
      cursor: pointer;
      transition: all 0.5s;
      z-index: 2;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 0.08rem;
        background: rgba($color: #E70012, $alpha: 0.21);
        animation: scalePulse 2s linear infinite;
      }

      .img-box {
        width: 0;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        transition: all 0.5s;
        overflow: hidden;

        img {
          width: 3.66rem;
          height: 1.68rem;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      &:hover {
        z-index: 77;

        &::before {
          width: 1rem;
        }

        .img-box {
          width: 3.66rem;
          height: 1.68rem;
        }
      }

      .map-hover-box-content {
        display: none;
      }


      &.map-hover-box7 {
        left: 37.7%;
        top: 50%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box8 {
        left: 38%;
        top: 49.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box3 {
        left: 37.3%;
        top: 50.8%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box9 {
        left: 38%;
        top: 55.4%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }

      }

      &.map-hover-box10 {
        left: 38.5%;
        top: 49.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box11 {
        left: 38.5%;
        top: 55%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }

      }


      &.map-hover-box12 {
        left: 38.5%;
        top: 54%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box2 {
        left: 38.4%;
        top: 52.4%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box13 {
        left: 38%;
        top: 54.5%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }
      }

      &.map-hover-box14 {
        left: 23%;
        top: 37%;
        border: #E70012 0.05rem solid;

        &::before {
          display: none;
        }
      }

      &.map-hover-box15 {
        left: 35%;
        top: 53.7%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box5 {
        left: 35.3%;
        top: 54%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box4 {
        left: 36.8%;
        top: 54.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box16 {
        left: 37%;
        top: 56.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box17 {
        left: 35%;
        top: 60.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box18 {
        left: 38%;
        top: 52%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box1 {
        left: 38%;
        top: 53.3%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box19 {
        left: 38.5%;
        top: 51.5%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box6 {
        left: 26%;
        top: 42%;
        border: #E70012 0.05rem solid;
      }

    }

  }

  .map-detail-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 88;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 17rem;
    height: auto;

    .map-detail-d {
      display: flex;
      justify-content: space-between;
      width: 16.1rem;
      background: #F1F1F1;
      border: 1px solid #060100;
      border-radius: 0.2rem;
      overflow: hidden;

      .map-detail-left {
        width: 7rem;
      }

      .map-detail-right {
        padding: 0.26rem 0.46rem;
        width: 8rem;

        .map-right-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.8rem;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -0.4rem;
            width: 0.52rem;
            height: 0.02rem;
            background: #E70012;
          }

          .map-detail-name {
            font-weight: 600;
            font-size: 0.3rem;
          }

          .map-detail-address {
            display: flex;
            align-items: center;
            gap: 0.1rem;
            font-weight: 300;
            font-size: 0.22rem;
            text-wrap: nowrap;

            img {
              width: 0.19rem;
              height: auto;
            }
          }
        }

        .map-right-bottom {
          font-weight: 300;
          font-size: 0.22rem;
          line-height: 0.34rem;
          text-align: justify;
        }
      }
    }

    .map-detail-icon {
      width: 0.37rem;
      height: auto;
      cursor: pointer;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

  }
}

.culture-master {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.5rem;
  width: 80% !important;
  height: auto;
  object-fit: cover;
}


@keyframes scalePulse {
  0% {
    width: 0.08rem;
    height: 0.08rem;
    border-radius: 0.08rem;
    opacity: 1;
  }

  100% {
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 0.32rem;
  }
}

@media (max-width: 768px) {
  .about-first {
    padding: 1rem 0.45rem;

    .about-kv-t1 {
      font-size: 0.5rem;
    }

    .about-video-list {
      flex-direction: column;

      .about-video-item {
        .about-video-bottom {
          background: #F4F4F4;

          .about-video-title {
            font-size: 0.32rem;
          }
        }
      }
    }
  }

  .about-map-box {
    .about-map-item {
      .about-map-text {
        top: 1.23rem;
        width: 5.68rem;

        .about-map-btn-list {
          display: flex;
          gap: 0.11rem;
          justify-content: center;
          align-items: center;
          width: 5.68rem;
          height: 0.68rem;
          background: rgba($color: #002D4C, $alpha: 0.12);
          border-radius: 0.27rem;
          color: #fff;

          .about-map-btn {
            width: 1.71rem;
            height: 0.52rem;
            background: rgba($color: #fff, $alpha: 0.3);
            border-radius: 0.2rem;
            color: #002D4C;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.16rem;
            font-weight: 400;
            cursor: pointer;
            gap: 0.05rem;

            div {
              width: 0.1rem;
              height: 0.1rem;
              border-radius: 50%;
            }

            &.active {
              background: #fff;
            }
          }
        }
      }

      .map-hover-box {
        .map-hover-box-content {
          display: flex;
          gap: 0.05rem;
          width: auto;
          position: absolute;

          .map-hover-box-title {
            font-size: 0.17rem;
            width: 1.7rem;
          }

          &.lt {
            right: 0;
            bottom: 0;
          }

          &.rt {
            left: 0;
            bottom: 0;
          }
          &.rb{
            left: 0;
            top: 0;
            align-items: flex-end;
            .map-hover-box-title{
              transform: translateY(50%);
            }
          }
          &.lb{
            right: 0;
            top: 0;
            align-items: flex-end;
            .map-hover-box-title{
              transform: translateY(50%);
            }
          }
        }

        &.map-hover-box10 {
          left: 53.5%;
          top: 54.5%;
        }

        &.map-hover-box8 {
          left: 50%;
          top: 54.5%;
          z-index: 6;
          
        }

        &.map-hover-box3 {
          left: 47.3%;
          top: 55.8%;
          z-index: 7;
        }

        &.map-hover-box2 {
          left: 54.4%;
          top: 57.4%;
        }

        &.map-hover-box1 {
          left: 52%;
          top: 58.3%;
        }

        &.map-hover-box4 {
          left: 48.8%;
          top: 59.3%;
          z-index: 8;
        }

        &.map-hover-box5 {
          left: 44.3%;
          top: 59%;
          z-index: 9;
        }

        &.map-hover-box16 {
          left: 49%;
          top: 61%;
        }

        &.map-hover-box17 {
          left: 45%;
          top: 64.5%;
        }

        &.map-hover-box6 {
          left: 20%;
          top: 45%;
        }


        // 变速器工厂

        &.map-hover-box7 {
          left: 50.7%;
          top: 55%;
        }

        &.map-hover-box19 {
          left: 54.5%;
          top: 57.5%;
        }

        &.map-hover-box18 {
          left: 52%;
          top: 58%;
        }

        &.map-hover-box12 {
          left: 55.5%;
          top: 59%;
        }

        &.map-hover-box15 {
          left: 48%;
          top: 58.7%;
        }


        // 电子工厂
        &.map-hover-box13 {
          left: 53%;
          top: 57.5%;
        }

        &.map-hover-box11 {
          left: 55.5%;
          top: 59%;
        }

        &.map-hover-box9 {
          left: 53%;
          top: 59.4%;
        }
      }


      // &.map-hover-box9,
      // &.map-hover-box10,

    }

    .map-detail-box {
      width: 6.6rem;
      flex-direction: column;
      align-items: center;
      gap: 0.2rem;

      .map-detail-d {
        flex-direction: column;
        width: 6.6rem;

        .map-detail-right {
          padding: 0.45rem 0.3rem;
          width: calc(100% - 0.6rem);
        }

        .map-detail-left {
          width: 100%;
        }
      }
    }
  }
  .about-full-video{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    .about-full-video-close{
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
</style>